import { action } from "satcheljs";

import type { AccountSource } from "../store/schema/AccountSourceList";

export interface ON_COPRINCIPAL_ACCOUNT_ADDEDActionMessage {
    addedAccount: AccountSource;
}
const defaultExport: (addedAccount: AccountSource) => ON_COPRINCIPAL_ACCOUNT_ADDEDActionMessage = action("ON_COPRINCIPAL_ACCOUNT_ADDED", (addedAccount: AccountSource): ON_COPRINCIPAL_ACCOUNT_ADDEDActionMessage => ({
    addedAccount,
}));
export default defaultExport;
